import { isNcl } from "utils/app/utils";

export const selectFavouritesData = (state) => ({
    favouritesList: state.menu.favourites.list,
    servicesByKey: state.menu.servicesByKey
});

export const selectHomeData = (state) => ({
    homeService: state.app.services.home,
    isHomePageEnabled: isNcl() || ((state.features.active['NetApp.Home/*'] && process.env.REACT_APP_IS_SAAS === 'true') ?? false)
});

export const selectCategoriesData = (state) => ({
    navItems: state.menu.navItems,
    servicesByTo: state.menu.servicesByTo,
    activeFeatures: state.features.active,
    isHomePageEnabled: isNcl() || ((state.features.active['NetApp.Home/*'] && process.env.REACT_APP_IS_SAAS === 'true') ?? false)
});